import {useQuery} from '@apollo/react-hooks';

import GET_FOLLOW_UP_TASKS_ELIGIBILITY from '../queries/get-follow-up-tasks-eligibility.graphql';

type GetFollowUpTasksEligibilityData = {
    loggedInUser: {
        id: string;
        isAiFollowUpTasksEnabled: boolean;
        hasRecentTranscriptionSummary: boolean;
    };
};

export function useGetFollowUpTasksEligibility(): {
    isLoading: boolean;
    isAiFollowUpTasksEnabled: boolean | null;
    hasRecentTranscriptionSummary: boolean | null;
} {
    const {loading, data} = useQuery<GetFollowUpTasksEligibilityData>(
        GET_FOLLOW_UP_TASKS_ELIGIBILITY,
        {
            fetchPolicy: 'network-only',
        }
    );

    const user = data ? data.loggedInUser : null;

    return {
        isLoading: loading,
        isAiFollowUpTasksEnabled: user ? user.isAiFollowUpTasksEnabled : null,
        hasRecentTranscriptionSummary: user ? user.hasRecentTranscriptionSummary : null,
    };
}
